import { ButtonIcon } from '@/app/common';

interface GalleryMobileArrowsProps {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
}

export const GalleryMobileArrows = ({
  canScrollLeft,
  canScrollRight,
  onScrollLeft,
  onScrollRight,
}: GalleryMobileArrowsProps) => {
  return (
    <div className="flex md:hidden flex-row gap-sm mt-6">
      <ButtonIcon variant="icon" iconName="ChevronLeft" isDisabled={!canScrollLeft} onClick={onScrollLeft} />
      <ButtonIcon variant="icon" iconName="ChevronRight" isDisabled={!canScrollRight} onClick={onScrollRight} />
    </div>
  );
};
